import React from 'react';
import { Drawer } from 'antd';
const DrawerCommon = ( {children, title, open, setOpen} ) => {

  const onClose = () => {
    setOpen(false);
  };

  const footer = (
    <div className="Drawer-footer">
      <div onClick={onClose}>
        {"Apply Filter"}
      </div>
    </div>
  )

  return (
    <>
      <Drawer title={title} placement="top" onClose={onClose} open={open} footer={footer} height={"100%"}>
        {children}
      </Drawer>
    </>
  );
};
export default DrawerCommon;